const leftArrow = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 37.635 37.636"
    >
      <g id="Group_1" data-name="Group 1" transform="translate(-422 340)">
        <path
          id="Path_1"
          data-name="Path 1"
          d="M37.635,18.818A18.817,18.817,0,1,1,18.817,0,18.818,18.818,0,0,1,37.635,18.818"
          transform="translate(422 -340)"
          fill="#5a3622"
        />
        <path
          id="Path_2"
          data-name="Path 2"
          d="M21.778,31.248l3.08-3.08-9.35-9.35,9.35-9.35-3.08-3.081L9.348,18.818Z"
          transform="translate(422 -340)"
          fill="#fff"
        />
      </g>
    </svg>
  );

  const rightArrow = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 37.635 37.636"
    >
      <g id="Group_2" data-name="Group 2" transform="translate(-1785.732 340)">
        <path
          id="Path_3"
          data-name="Path 3"
          d="M1363.732,18.818a18.817,18.817,0,1,1,18.818,18.818,18.818,18.818,0,0,1-18.818-18.818"
          transform="translate(422 -340)"
          fill="#5a3622"
        />
        <path
          id="Path_4"
          data-name="Path 4"
          d="M1379.589,6.387l-3.08,3.08,9.35,9.35-9.35,9.35,3.08,3.081,12.43-12.431Z"
          transform="translate(422 -340)"
          fill="#fff"
        />
      </g>
    </svg>
  );

export { leftArrow, rightArrow };